export default __webpack_public_path__ + "static/media/cha_medic_sussurro.953ab243.png";